// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"7c16693b","850":"a8af4da4"}[chunkId] + ".chunk.js";
};